export enum Gender {
  Female = 'female',
  Male = 'male',
  Any = 'any',
}
